import Swiper, { Autoplay, Parallax, EffectFade } from 'swiper'
import 'swiper/modules/parallax/parallax.scss'
import 'swiper/modules/effect-fade/effect-fade.scss'


document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-product-showcase')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const productBoxes = sliderWrapper.querySelectorAll('.mtt-product-showcase__product-box')
      const swiperElement = sliderWrapper.querySelector('.swiper')
      const speed = 700

      const swiperOptions = {
        modules: [ Autoplay, Parallax, EffectFade ],
        effect: 'fade',
        allowTouchMove: false,
        speed: speed,
        slidesPerView: 1,
        threshold: 8,
        loop: false,
        parallax: true,
        grabCursor: false,
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        on: {
          afterInit() {
            sliderWrapper.querySelector('.mtt-product-showcase__product-box[data-id="0"]').classList.add('active')
            sliderWrapper.querySelector('.mtt-product-showcase__product-box[data-id="0"]').classList.add('progress')
          },
        },
      }

      const swiper = new Swiper(swiperElement, swiperOptions)
      //
      swiperElement.addEventListener('mouseenter', function () {
        swiper.autoplay.stop();
        sliderWrapper.querySelector('.mtt-product-showcase__product-box.active.progress').classList.remove('progress')
      })

      swiperElement.addEventListener('mouseleave', function () {
        swiper.autoplay.start();
        sliderWrapper.querySelector('.mtt-product-showcase__product-box.active').classList.add('progress')
      })

      swiper.on('slideChange', function () {
        const ACTIVE = sliderWrapper.querySelector('.mtt-product-showcase__product-box.active')
        ACTIVE.classList.remove('active')
        ACTIVE.classList.remove('progress')
        sliderWrapper.querySelector('.mtt-product-showcase__product-box[data-id="'+swiper.activeIndex+'"]').classList.add('active')
        setTimeout(() => {
          sliderWrapper.querySelector('.mtt-product-showcase__product-box[data-id="'+swiper.activeIndex+'"]').classList.add('progress')
        }, speed)
      })

      if (productBoxes.length > 0) {
        for (let i = 0; i < productBoxes.length; i++) {
          productBoxes[i].addEventListener('click', (event) => {
            const ID = productBoxes[i].getAttribute('data-id')
            swiper.slideTo((ID))
          })
        }
      }
    })
  }
})